// DS: i3.32
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const SubtractCircle: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.6719 2.32861C12.1191 0.776367 10.2241 0 7.98596 0C5.78625 0 3.91003 0.776367 2.3573 2.3291C0.786011 3.92896 0 5.81934 0 8.00024C0 10.1904 0.786011 12.0715 2.3573 13.6426C3.94751 15.2144 5.82349 16 7.98572 16C10.1948 16 12.1045 15.2095 13.7139 13.6284C15.238 12.1143 16.0002 10.2385 16.0002 8C16.0002 5.76147 15.2236 3.87158 13.6719 2.32861ZM3.40051 3.37158C4.65771 2.08545 6.19629 1.44287 8.01514 1.44287C9.8335 1.44287 11.3762 2.08545 12.6431 3.37158C13.9187 4.62891 14.5571 6.17188 14.5571 8C14.5571 9.83838 13.9285 11.3667 12.6714 12.5857C11.3477 13.8906 9.79541 14.5427 8.01465 14.5427C6.22375 14.5427 4.68103 13.8955 3.38574 12.6001C2.0907 11.3142 1.44324 9.78125 1.44324 8C1.44324 6.23853 2.09546 4.6958 3.40051 3.37158ZM5 9H11V7H5V9Z"
        fill="currentColor"
      />
    </svg>
  </IconWrap>
);
SubtractCircle.displayName = 'SubtractCircle';

export default SubtractCircle;
